import React from "react";
import BillPaymentList from "./BillPaymentList";

const BillPayments = () => {
  return (
    <div className="bill-payments-page-wrapper">
      <BillPaymentList />
    </div>
  );
};

export default BillPayments;